<template>
  <template v-if="sidebarComponents.length === 0">
    <div class="latestproperties-wrapper tw-overflow-hidden">
      <svg
        v-if="bannerText === 1"
        class="tw-z-50"
        width="1920"
        height="74"
        viewBox="0 0 1920 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="74" height="226" transform="matrix(0 1 1 0 0 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 119.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 135.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 135.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 150.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 166.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 166.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 181.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 196.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 196.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 212.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 0.25293 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 15.5542 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 15.5542 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 31.1738 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 46.4756 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 46.4756 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 62.0942 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 77.3955 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 77.3955 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 93.0161 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 105.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 105.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 212 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 331.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 347.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 347.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 362.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 378.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 378.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 393.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 408.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 408.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 424.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 212.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 227.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 227.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 243.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 258.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 258.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 274.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 289.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 289.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 305.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 317.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 317.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 424 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 543.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 559.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 559.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 574.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 590.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 590.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 605.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 620.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 620.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 636.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 424.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 439.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 439.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 455.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 470.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 470.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 486.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 501.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 501.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 517.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 529.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 529.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 636 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 755.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 771.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 771.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 786.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 802.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 802.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 817.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 832.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 832.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 848.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 636.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 651.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 651.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 667.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 682.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 682.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 698.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 713.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 713.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 729.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 741.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 741.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 848 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 967.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 983.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 983.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 998.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1014.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1014.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1029.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1044.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1044.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1060.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 848.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 863.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 863.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 879.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 894.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 894.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 910.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 925.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 925.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 941.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 953.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 953.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1060 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1179.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1195.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1195.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1210.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1226.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1226.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1241.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1256.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1256.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1272.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1060.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1075.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1075.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1091.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1106.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1106.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1122.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1137.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1137.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1153.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1165.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1165.96 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1272 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1391.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1407.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1407.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1422.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1438.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1438.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1453.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1468.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1468.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1484.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1272.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1287.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1287.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1303.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1318.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1318.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1334.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1349.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1349.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1365.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1377.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1377.96 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1483 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1602.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1618.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1618.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1633.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1649.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1649.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1664.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1679.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1679.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1695.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1483.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1498.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1498.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1514.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1529.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1529.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1545.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1560.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1560.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1576.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1588.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1588.96 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1694 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1813.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1829.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1829.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1844.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1860.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1860.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1875.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1890.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1890.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1906.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1694.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1709.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1709.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1725.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1740.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1740.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1756.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1771.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1771.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1787.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1799.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1799.96 8.53979)"
          fill="white"
        />
      </svg>
      <div id="project-standard" class="project-section pt-60 pb-120 tw-overflow-hidden">
        <div class="container">
          <h2 class="tw-mb-8 tw-self-center tw-text-center">{{ vars.titleText }}</h2>
          <div class="row">
            <div class="project-slider-2 owl-carousel">
              <a
                v-for="(property, index) in mixedProperties"
                :key="property.id || index"
                class="single-project-wrapper n-link"
              >
                <theme9-properties-property-list-item
                  :property="property"
                  :is-match-information-hidden="true"
                  :pre-market-property-feature="true"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  :is-vertical="true"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <svg
        v-if="bannerText === 2"
        class="tw-z-50"
        width="1920"
        height="74"
        viewBox="0 0 1920 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- (SVG içeriğini buraya aynen yapıştırın) -->
        <rect width="74" height="226" transform="matrix(0 1 1 0 0 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 119.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 135.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 135.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 150.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 166.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 166.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 181.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 196.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 196.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 212.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 0.25293 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 15.5542 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 15.5542 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 31.1738 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 46.4756 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 46.4756 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 62.0942 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 77.3955 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 77.3955 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 93.0161 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 105.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 105.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 212 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 331.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 347.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 347.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 362.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 378.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 378.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 393.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 408.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 408.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 424.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 212.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 227.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 227.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 243.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 258.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 258.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 274.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 289.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 289.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 305.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 317.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 317.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 424 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 543.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 559.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 559.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 574.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 590.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 590.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 605.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 620.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 620.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 636.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 424.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 439.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 439.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 455.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 470.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 470.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 486.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 501.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 501.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 517.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 529.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 529.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 636 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 755.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 771.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 771.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 786.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 802.014 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 802.014 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 817.634 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 832.935 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 832.935 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 848.555 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 636.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 651.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 651.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 667.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 682.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 682.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 698.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 713.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 713.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 729.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 741.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 741.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 848 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 967.792 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 983.093 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 983.093 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 998.712 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1014.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1014.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1029.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1044.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1044.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1060.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 848.253 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 863.554 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 863.554 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 879.174 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 894.476 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 894.476 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 910.094 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 925.396 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 925.396 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 941.016 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 953.703 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 953.964 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1060 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1179.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1195.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1195.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1210.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1226.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1226.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1241.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1256.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1256.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1272.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1060.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1075.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1075.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1091.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1106.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1106.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1122.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1137.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1137.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1153.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1165.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1165.96 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1272 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1391.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1407.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1407.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1422.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1438.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1438.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1453.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1468.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1468.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1484.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1272.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1287.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1287.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1303.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1318.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1318.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1334.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1349.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1349.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1365.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1377.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1377.96 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1483 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1602.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1618.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1618.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1633.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1649.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1649.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1664.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1679.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1679.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1695.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1483.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1498.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1498.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1514.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1529.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1529.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1545.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1560.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1560.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1576.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1588.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1588.96 8.53979)"
          fill="white"
        />
        <rect width="74" height="226" transform="matrix(0 1 1 0 1694 0)" fill="#E4002B" />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1813.79 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1829.09 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1829.09 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1844.71 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1860.01 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1860.01 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1875.63 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1890.94 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1890.94 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1906.55 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1694.25 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1709.55 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1709.55 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1725.17 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1740.48 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1740.48 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1756.09 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1771.4 53.5891)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1771.4 8.57275)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1787.02 30.7617)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1799.7 53.5095)"
          fill="white"
        />
        <ellipse
          cx="6.34057"
          cy="6.37544"
          rx="6.34057"
          ry="6.37544"
          transform="matrix(0 1 1 0 1799.96 8.53979)"
          fill="white"
        />
      </svg>
    </div>
  </template>
  <template v-else-if="sidebarComponents.length > 0">
    <div id="project-standard" class="project-section pt-60 pb-120 tw-overflow-hidden">
      <div class="container">
        <h2 class="tw-mb-8 tw-self-center tw-text-center">{{ vars.titleText }}</h2>
        <div class="row">
          <div class="project-slider-2 owl-carousel">
            <a
              v-for="(property, index) in mixedProperties"
              :key="property.id || index"
              class="single-project-wrapper n-link"
            >
              <theme9-properties-property-list-item
                :property="property"
                :is-match-information-hidden="true"
                :pre-market-property-feature="true"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                :is-vertical="true"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertiesMixin } from '~/units/properties/mixins/properties.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import { Pagination as SwiperPagination } from 'swiper/modules';

interface ComponentData {
  swiper: any | null;
  canPaginateBack: boolean;
  selectedProperty: any | null;
  isVisible: boolean;
  canPaginateNext: boolean;
  variants: {
    v1: string;
    v2: string;
  };
  swiperModules: any[];
}

export default defineNuxtComponent({
  name: 'Theme9LatestProperties',

  mixins: [ComponentMixin, PropertiesMixin],

  async setup(props: any) {
    try {
      await fetchPropertiesManager(props.component, null);
    } catch (error) {
      console.error('Error fetching properties:', error);
    }
  },

  data(): ComponentData {
    return {
      swiper: null,
      canPaginateBack: true,
      selectedProperty: null,
      isVisible: false,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      swiperModules: [SwiperPagination],
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    loopedProperties() {
      try {
        return this.properties ? [...this.properties, ...this.properties] : [];
      } catch (error) {
        console.error('Error in loopedProperties computed:', error);
        return [];
      }
    },

    bannerText(): number {
      return Number(this.vars.bannerText);
    },

    mixedProperties() {
      try {
        if (!this.properties || this.properties.length === 0) return [];

        const rentProperties = this.properties.filter((property) => property.is_rent);
        const saleProperties = this.properties.filter((property) => !property.is_rent);

        const result = [];
        const maxLength = Math.max(rentProperties.length, saleProperties.length);

        for (let i = 0; i < maxLength; i++) {
          if (i < saleProperties.length) result.push(saleProperties[i]);
          if (i < rentProperties.length) result.push(rentProperties[i]);
        }

        return result;
      } catch (error) {
        console.error('Error in mixedProperties computed:', error);
        return [];
      }
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    /**
     * Determines how many property cards should be rendered per slide for ≥768px viewports.
     * Requirement: if there are sidebar components we must show exactly **one** card per slide;
     * otherwise keep existing behaviour (two cards).
     */
    carouselItems(): number {
      return this.sidebarComponents && this.sidebarComponents.length > 0 ? 1 : 2;
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (process.client) {
        this.initCarousel();
      }
    });
  },

  watch: {
    mixedProperties(newVal) {
      if (newVal.length > 0) {
        this.$nextTick(() => {
          this.initCarousel();
        });
      }
    },
  },

  methods: {
    initCarousel() {
      if (typeof window !== 'undefined' && window.$ && window.$.fn.owlCarousel) {
        const $ = window.$;
        $('.project-slider-2').owlCarousel('destroy'); // Fix selector
        $('.project-slider-2').owlCarousel({
          loop: true,
          margin: 30,
          nav: true,
          dots: false,
          navText: ["<i class='las la-arrow-left'></i>", "<i class='las la-arrow-right'></i>"],
          responsive: {
            0: {
              items: 1,
            },
            768: {
              items: this.carouselItems,
            },
          },
        });
      } else {
        console.warn('jQuery or Owl Carousel not loaded');
      }
    },
  },
});
</script>
